export default __webpack_public_path__ + "static/media/lightrain.3b09d477.svg";